import React from "react";
import { Outlet } from "react-router-dom";
import { getBrandName } from "../../utility/branding";

const QUOTES = [
  {
    body: "Booking should feel like a conversation, not a checkout.",
    attr: "— studio principle",
  },
  {
    body: "A calendar is a quiet promise. Keep it.",
    attr: "— studio principle",
  },
  {
    body: "The best businesses respect the time of the people they serve.",
    attr: "— studio principle",
  },
];

const AuthPageContainer = () => {
  const quote = QUOTES[Math.floor(Math.random() * QUOTES.length)];

  return (
    <div className="min-h-screen bg-cream-50">
      <div className="grid min-h-screen lg:grid-cols-2">
        {/* Editorial pull-quote panel — desktop only */}
        <aside className="hidden lg:flex relative bg-cream-200 border-r border-ink-100 items-center px-12 py-16">
          <div className="max-w-md">
            <p className="smallcaps text-ink-400 mb-8">{getBrandName()}</p>
            <blockquote className="font-display text-3xl xl:text-4xl text-ink-900 leading-[1.15] tracking-display">
              “{quote.body}”
            </blockquote>
            <p className="mt-6 text-sm text-ink-500">{quote.attr}</p>
          </div>
          <span
            aria-hidden="true"
            className="absolute bottom-12 right-12 font-display text-[180px] leading-none text-ink-100 select-none pointer-events-none"
          >
            “
          </span>
        </aside>

        {/* Form panel */}
        <div className="flex flex-1 flex-col justify-center py-12 px-6 sm:px-12 lg:px-16 page-enter">
          <div className="mx-auto w-full max-w-md reveal-on-enter">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPageContainer;
